import { FC } from "react"
import { Lead } from "../../../../../../../types"
import SectionCell from "../../../../../section/cell"
import { calcDownPercentage } from "../../../../../../utils"
import {
  CurrencyValueCell,
  OptionValueToNameCell
} from "../../../../../section"
import If from "../../../../../if"

interface Props {
  data: Lead
  cols: number
}

const LoanScenario: FC<Props> = ({ data, cols }) => {
  const {
    details: {
      loan_amount,
      loan_purpose,
      property_type,
      list_price,
      residency_type,
      credit_score,
      down_payment,
      cash_out,
      household_income
    }
  } = data

  return (
    <div className={`grid grid-cols-${cols} gap-4`}>
      <OptionValueToNameCell label="Loan purpose" value={loan_purpose} />

      <CurrencyValueCell label="Loan amount" value={loan_amount} />

      <If
        condition={loan_purpose === "refinance"}
        then={<CurrencyValueCell label="Cash out" value={cash_out ?? 0} />}
        else={
          <>
            <CurrencyValueCell label="Down payment" value={down_payment ?? 0} />

            <SectionCell
              label="Down percentage"
              value={`${
                down_payment && loan_amount
                  ? calcDownPercentage({
                      list_price,
                      down_payment: parseFloat(down_payment)
                    })
                  : "-"
              }`}
            />
          </>
        }
      />

      <CurrencyValueCell label="List price" value={list_price} />

      <If
        condition={!!household_income}
        then={
          <CurrencyValueCell
            label="Household income"
            value={household_income ?? 0}
          />
        }
      />

      <SectionCell label="Credit score" value={credit_score} />
      <OptionValueToNameCell label="Property type" value={property_type} />
      <OptionValueToNameCell label="Residency type" value={residency_type} />
    </div>
  )
}

export default LoanScenario
